export default __webpack_public_path__ + "static/media/male_aorta-01.3166806b.png";